import React, { FC, useEffect } from 'react';
import { HeadingText50 } from '@modernhealth/vital-components';
import { CenteredSpinner } from 'src/shared/components/CenteredSpinner';
import { useTranslation } from 'react-i18next';
import { LoadingTestId } from './testIds';

interface LoadingProps {
    onNext: VoidFunction;
}

export const Loading: FC<LoadingProps> = ({ onNext }) => {
    const { t } = useTranslation();
    useEffect(() => {
        setTimeout(onNext, 2000); //from UI/UX perspective we want some loading when calculating if user is eligible
    }, [onNext]);

    return (
        <div data-testid={LoadingTestId.Wrapper}>
            <CenteredSpinner fontSize={60} />
            <HeadingText50 marginTop={100}>
                {t(`dependents:checking_eligibility.title`)}
            </HeadingText50>
        </div>
    );
};
